function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M47.998 44.999H33.999c-1.658 0-3-1.343-3-3v-4c0-.553.447-1 .999-1 .553 0 1.001.447 1.001 1v4c0 .552.448 1 1 1h13.999c.553 0 1-.448 1-1v-4c0-.553.449-1 1.001-1 .551 0 1 .447 1 1v4c0 1.657-1.343 3-3.001 3zm-7-20c.552 0 1.001.447 1.001 1v9.59l2.289-2.3c.392-.392 1.029-.392 1.42 0 .393.392.393 1.028 0 1.42l-4 4c-.095.091-.207.162-.33.21-.242.107-.517.107-.759 0-.123-.048-.236-.119-.33-.21l-4-4c-.393-.392-.393-1.028 0-1.42.392-.392 1.028-.392 1.419 0l2.29 2.3v-9.59c0-.553.449-1 1-1z"
});

var SvgExport = function SvgExport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "31 25 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/export.5375a2d7.svg";
export { ForwardRef as ReactComponent };